import React, { useState, useEffect, Suspense, lazy } from "react";
import useAuth from "../../../hooks/useAuth";
import "./AccountDetails.css";
import { useSelector } from "react-redux";
import CompanyPrimaryInfo from "./CompanyPrimaryInfo";
import KeyFinancials from "./KeyFinancials";
import RecentDevelopments from "./RecentDevelopments";
import { useSearchParams } from "react-router-dom";
import AccountQuarterlyUpdatesV2 from "./AccountQuarterlyUpdatesV2";
// import AccountBUOverview from "./AccountBUOverview";

// Lazy load the components
const KeyProducts = lazy(() => import("./KeyProducts"));
const RevenueAnalysis = lazy(() => import("./RevenueAnalysis"));
const KeyConversations = lazy(() => import("./KeyConversations"));
const OpportunitiesAnalysisTable = lazy(() => import("./OpportunitiesAnalysisTable"));
const KeyCompetitorsTable = lazy(() => import("./KeyCompetitorsTable"));
const AccountBUOverview = lazy(() => import("./AccountBUOverview"));

export default function CompanyOverview({ active_tab_key }) {
  useAuth();

  const { account_info, account_details} = useSelector(state => state?.accountsReducer);
  const accountTicker = account_info?.ticker || '';

  const [recentDevelopmentsData, setRecentDevelopmentsData] = useState({});
  const [numOfTotalKeyDevelopments, setNumOfTotalKeyDevelopments] = useState({});
  const [clientProductOpportunitiesData, setClientProductOpportunitiesData] = useState({});
  // const [key_products_services, setKeyProducts] = useState([]);


  useEffect(() => {
    if (active_tab_key === "overview") {
    }
  }, [active_tab_key]);

  useEffect(() => {
    // if (account_info && account_info.business_units) {
    //   setKeyProducts(account_details?.key_products_services || []);
    // }

    if (account_info && account_info.key_developments) {
      const keyDevelopmentData = account_info?.key_developments || {};
      setNumOfTotalKeyDevelopments(keyDevelopmentData.total || 0);
      setRecentDevelopmentsData(keyDevelopmentData?.results || []);
    }

    if (account_details?.client_product_opportunities) {
      const clientProductOpportunitiesData = account_details?.client_product_opportunities || {};
      setClientProductOpportunitiesData(clientProductOpportunitiesData);
    }

  }, [account_info, account_details]);

  let ticker = accountTicker || '';



  const [, setSearchParams] = useSearchParams();
  useEffect(() => {
    setSearchParams({
      tab: "accountPlan",
    });
  }, []);
  return (
    <div className="container-fluid mt-4">
      
      <div className="generic-take-space-parent">

          <CompanyPrimaryInfo />
    
          <KeyFinancials />
       
      </div>
       
       <div className="row">
          <div className="container-fluid">
            <div className="row">
              {numOfTotalKeyDevelopments > 0 && <div className="col-md-12 mb-2">
                <Suspense fallback={null}>
                  <RecentDevelopments
                    numOfDevelopments={numOfTotalKeyDevelopments}
                    recentDevelopmentsData={recentDevelopmentsData}
                  />
                </Suspense>
              </div>
              }

              <div className="col-md-12 mb-2">
                <Suspense fallback={null}>
                  <RevenueAnalysis />
                </Suspense>
              </div>

              <div className="col-md-12 mb-2">
                <Suspense fallback={null}>
                  <AccountBUOverview />
                </Suspense>
              </div>

              <div className="col-md-12 mb-2">
                <Suspense fallback={null}>
                  <AccountQuarterlyUpdatesV2 />
                </Suspense>
              </div>

              <div className="col-md-12 mb-2">
                <Suspense fallback={null}>
                  <KeyConversations />
                </Suspense>
              </div>

              <div className="col-md-12">
                <Suspense fallback={null}>
                  <KeyCompetitorsTable ticker={ticker} active_tab_key={active_tab_key} />
                </Suspense>
              </div>
              {Object.keys(clientProductOpportunitiesData).length > 0 && <div className="col-md-12 ">
                <Suspense fallback={null}>
                  <OpportunitiesAnalysisTable clientProductOpportunitiesData={clientProductOpportunitiesData} />
                </Suspense>
              </div>
              }
            <Suspense fallback={null}>
                <KeyProducts />
              </Suspense>
            </div>
            
          </div>
          
        </div>
      


    </div>
  );
}